module.exports = __webpack_public_path__ + "img/resized-APP-0010-2.0e76dca3.png";